import {
  Checkbox,
  ChoiceGroup,
  getTheme,
  Link,
  Stack,
  Text
} from "@fluentui/react";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { lineAdditionalServicePaymentMethodOptions } from "../../constants";
import { LineAdditionalServiceType } from "../../interfaces";

import { PaymentMethodType } from "@/common/types/PaymentMethod.types";

interface PaymentMethodFormValues {
  type: LineAdditionalServiceType;
  isChargeExempt: boolean;
  paymentMethod: PaymentMethodType.INVOICE_DEBIT | PaymentMethodType.PIX;
}

export function LineAdditionalServicePaymentMethodForm(): JSX.Element {
  const theme = getTheme();
  const [isCustomizationVisible, setIsCustomizationVisible] = useState(false);
  const { control, setValue, watch } =
    useFormContext<PaymentMethodFormValues>();
  const isChargeExempt = watch("isChargeExempt");
  const isActivationCSelected =
    watch("type") !== LineAdditionalServiceType.DATA_BONUS;

  return (
    <>
      {!isChargeExempt && (
        <Controller
          name="paymentMethod"
          control={control}
          rules={{ required: "Selecione o método de pagamento." }}
          render={({ field, fieldState }) => (
            <Stack tokens={{ childrenGap: 4 }}>
              <ChoiceGroup
                label="Método de Pagamento"
                options={lineAdditionalServicePaymentMethodOptions}
                selectedKey={field.value}
                onChange={(_, option) => field.onChange(option?.key)}
                required
              />

              {fieldState.error?.message && (
                <Text
                  variant="small"
                  role="alert"
                  styles={{
                    root: { color: theme.palette.redDark }
                  }}
                >
                  {fieldState.error.message}
                </Text>
              )}
            </Stack>
          )}
        />
      )}

      <Link
        onClick={() => {
          if (isCustomizationVisible) {
            setValue("isChargeExempt", false);
          }

          setIsCustomizationVisible(currentValue => !currentValue);
        }}
        styles={{
          root: {
            color: theme.palette.themePrimary,
            width: "fit-content"
          }
        }}
      >
        Personalizar
      </Link>

      {isCustomizationVisible && (
        <Checkbox
          label={
            isActivationCSelected
              ? "Isentar cobrança da Ativação C"
              : "Isentar cobrança do Bônus de Internet"
          }
          checked={isChargeExempt}
          onChange={(_, checked) =>
            setValue("isChargeExempt", Boolean(checked))
          }
        />
      )}
    </>
  );
}
